import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import axios from "axios";

/**
 * Renders a button which, when selected, will open a popup for login
 */
export const Authorization = (props) => {
    const history = useHistory();
    const location = useLocation();
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const loginPage = '/login';

    useEffect(() => {
        const currentPath = window.location.pathname + window.location.search;
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: accounts[0]
        };

        const handleLogin = async () => {
            try {
                const accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest);
                const accessToken = accessTokenResponse.accessToken;

                await axios.get(`${process.env.REACT_APP_API_URL}/sanctum/csrf-cookie`);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/loginAD`, { token: accessToken });

                localStorage.setItem('token', response.data.token);
                const destination = localStorage.getItem('destination');
                if (!destination) {
                    history.push("/home");
                } else {
                    localStorage.removeItem('destination');
                    history.push(destination);
                }
            } catch (error) {
                console.error(error);
                if (error.response) {
                    console.error(error.response.data.msg);
                } else if (error.errorCode === "interaction_required" || error.errorCode === "login_required" || error.errorCode === "consent_required") {
                    instance.loginRedirect(accessTokenRequest).catch(console.error);
                } else {
                    console.error('User not found.');
                }
            }
        };

        if (location.pathname !== '/auth') {
            localStorage.setItem('destination', currentPath);
        }

        if (inProgress === InteractionStatus.None && isAuthenticated) {
            handleLogin();
        } else if (inProgress === InteractionStatus.None && !isAuthenticated) {
            instance.loginRedirect(accessTokenRequest).catch(console.error);
        }
    }, [inProgress, isAuthenticated, accounts, instance, history, location.pathname]);

    return null;
}